function initDirectCheckoutAfterAddToCart() {
  var productForms = document.querySelectorAll('form[action*="/cart/add"]');

  if (!productForms.length) return;

  productForms.forEach(function (form) {
    if (form.dataset.directCheckoutBound === 'true') return;
    form.dataset.directCheckoutBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw data;
            });
          }

          return response.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (error) {
          console.error('Add to cart failed:', error);

          if (error && error.description) {
            alert(error.description);
            return;
          }

          alert('Could not add product to cart.');
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    initDirectCheckoutAfterAddToCart();
  }, 200);

  var observer = new MutationObserver(function () {
    initDirectCheckoutAfterAddToCart();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});